import { Link } from 'react-router-dom';
import CreateEventForm from '../components/events/CreateEventForm';

export default function CreateEventPage() {
  return (
    <div className="max-w-3xl mx-auto p-4">
      {/* Back button */}
      <Link
        to="/events"
        className="inline-flex items-center text-blue-500 hover:text-blue-700 mb-4"
      >
        <svg
          className="w-5 h-5 mr-1"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
        Tilbage til begivenheder
      </Link>

      {/* Page header */}
      <div className="bg-white rounded-lg shadow p-6 mb-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Opret ny begivenhed
        </h1>
        <p className="text-gray-600">
          Organiser en begivenhed for klanen
        </p>
      </div>

      {/* Create form */}
      <div className="bg-white rounded-lg shadow p-6">
        <CreateEventForm />
      </div>
    </div>
  );
}
